import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mass-communication',
  templateUrl: './mass-communication.component.html',
  styleUrls: ['./mass-communication.component.scss']
})
export class MassCommunicationComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
